<template>
  <div>
    <v-card>
      <v-card-text class="text--primary">
        <px-cotacao-conjunta-resposta-finalizacao-table
          :resposta="solicitacao.respostaCotacaoConjunta" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CotacaoConjuntaRespostaFinalizacaoTable
  from '@/modules/compra-conjunta/responder/CotacaoConjuntaRespostaFinalizacaoTable.vue';

export default {
  props: {
    solicitacao: Object,
  },
  components: {
    pxCotacaoConjuntaRespostaFinalizacaoTable: CotacaoConjuntaRespostaFinalizacaoTable,
  },
};
</script>
